import moment from 'moment';

export default class MemberContractHistory {
    static fromData(data) {
        if (!data) {
            return;
        }

        let history = new MemberContractHistory();
        history.contracts = data.map(contract => {
            return {
                id: contract.id,
                type: contract.type,
                membershipNumber: contract.membershipNumber,
                start: moment(contract.start),
                end: contract.end == null ? null : moment(contract.end),
            }
        });

        return history;
    }

    current() {
        return this.contracts.find(contract => contract.start <= moment() && (contract.end == null || contract.end > moment()));
    }

    further() {
        let current = this.current();
        return this.contracts.filter(contract => current == null || contract.id !== current.id);
    }
}
